import { find, flatten, map } from 'es-toolkit/compat';

// Define types for the data structures
type NamedItem = {
    name: string;
};

type ColorItem = {
    class: string;
    background: string;
};

type ClassItem = {
    class: string;
    value: string;
};

type BreakpointItem = {
    name: string;
    minWidth: string;
    maxWidth: string;
};

// Generic type for items that can be flattened
type FlattenableItem<T> = T | T[];

const mapItems = <T, U>(items: FlattenableItem<T>[], mapper: (items: T[]) => U): U => mapper(flatten(items) as T[]);

export const getNames = (...args: FlattenableItem<NamedItem>[]): string[] =>
    mapItems(args, items => map(items, (item: NamedItem) => item.name));

export const getClasses = (...args: FlattenableItem<ClassItem | ColorItem>[]): string[] =>
    mapItems(args, items => map(items, (item: ClassItem | ColorItem) => item.class));

export const getBackgrounds = (...args: FlattenableItem<ColorItem>[]): string[] =>
    mapItems(args, items => map(items, (color: ColorItem) => color.background));

// Example type: [{
//   class: 'line-height-10',
//   value: '10',
// }]
export const findByClass = (value: string, array: ClassItem[]): ClassItem | undefined =>
    find(array, (item: ClassItem) => item.class === value);

// Example type: [{
//   name: 'ls',
//   minWidth: '480px',
//   maxWidth: '767.99px',
// }]
export const findByName = <T extends { name: string }>(value: string, array: T[]): T | undefined =>
    find(array, (item: T) => item.name === value);
